import styled from '@emotion/styled'

export default styled.div`
  width: 90%;
  min-width: 400px;
  max-width: 1044px;
  margin: 0 auto;
  position: relative;
`
